// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3seLm","right":"Footer_right__RLkeT","buttons":"Footer_buttons__10Z8R"};